import UpdateAcronisBackupSettings from './Update';

export default UpdateAcronisBackupSettings;
